import React from 'react';
import { TableBody, TableCell, TableRow } from '@mui/material';
import { taskServicesConfig } from '../taskConfig.ts';
import { tasksPageStyles } from '../styles.ts';
import TaskTableRow from './TaskTableRow.tsx';
import type { ITasksServiceTableBodyProps } from './types.ts';

const TasksServiceTableBody: React.FC<ITasksServiceTableBodyProps> = ({
  activeGuaranteesActionId,
  canAssignGuaranteesTask,
  emptyText,
  onGuaranteesAssignTask,
  onGuaranteesRefuseTask,
  onGuaranteesSlaDeadlineReached,
  onGuaranteesTakeInWork,
  rows,
  serviceKey,
}) => {
  const serviceConfig = taskServicesConfig[serviceKey];
  const totalColumns = 6;

  return (
    <TableBody>
      {!rows.length ? (
        <TableRow>
          <TableCell colSpan={totalColumns} align="center" sx={tasksPageStyles.emptyTableCell}>
            {emptyText ?? serviceConfig.emptyText}
          </TableCell>
        </TableRow>
      ) : (
        rows.map((row) => (
          <TaskTableRow
            key={row.id}
            actionPath={serviceConfig.actionPath}
            activeGuaranteesActionId={activeGuaranteesActionId}
            canAssignGuaranteesTask={canAssignGuaranteesTask}
            onGuaranteesAssignTask={onGuaranteesAssignTask}
            onGuaranteesRefuseTask={onGuaranteesRefuseTask}
            onGuaranteesSlaDeadlineReached={onGuaranteesSlaDeadlineReached}
            onGuaranteesTakeInWork={onGuaranteesTakeInWork}
            row={row}
          />
        ))
      )}
    </TableBody>
  );
};

export default TasksServiceTableBody;
